import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-xl px-3 py-2 text-base md:text-sm",
          "bg-[hsl(var(--glass-bg))] backdrop-blur-md",
          "border border-[hsl(var(--glass-border-strong))]",
          "shadow-[inset_0_1px_0_hsl(var(--glass-highlight)),inset_0_-1px_2px_hsl(var(--glass-shadow))]",
          "ring-offset-background placeholder:text-muted-foreground",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
          "focus-visible:bg-[hsl(var(--glass-bg-strong))] focus-visible:border-[hsl(var(--glass-border))]",
          "transition-all duration-300",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
